import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Input, Space, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import Header from "../../Header/Header";
import SideBar from "../../SideBar/SideBar";
import Footer from "../../Footer/Footer";

import "../normalsearch.css";

import Pagination from "../Base UI/Pagination";
import { getAllIssues, getAllIssuesByStatus, getAllIssuesSort, searchIssues, updateIssuesDetails } from "../../HttpRequest/issues";
import MyForm from "../Reusecomponent/UniversityShortlistingProfile";

const Issues = () => {
  const [data, setData] = useState([]);
  const [isFocused1, setIsFocused1] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [pagedata, setPageData] = useState();
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });
  const [sortOrder, setSortOrder] = useState();
  const [profileData, setProfileData] = useState([]);
  const [idData, setidData] = useState([]);
  const [lookingData, setLookingData] = useState("looking for something else");
  const [lookingForSomeThingElse, setLookingForSomeThingElse] = useState(true);
  const [someThingWentWrong, setSomeThingWentWrong] = useState(false);
  const handleCheckbox1 = () => {
    setLookingData("looking for something else");
    setLookingForSomeThingElse(!lookingForSomeThingElse);
    setSomeThingWentWrong(false);
  };

  const handleCheckbox2 = () => {
    setLookingData("found something wrong");
    setSomeThingWentWrong(!someThingWentWrong);
    setLookingForSomeThingElse(false);
  };

  const setPageInfoData = (data) => {
    console.log("page data to parent-->", data);
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    category: "",
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [checkedIndex, setCheckedIndex] = useState(1);

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    fetchData();
    setIsModalVisible(false);
  };

  useEffect(() => {
    fetchData();
  }, [pageInfo, sortOrder, lookingForSomeThingElse]);

  const handleNameSort = async (order) => {
    console.log("order ==>", order);
    if (order == "asc") {
      setSortOrder({ fieldName: "name", direction: "asc" });
    } else {
      console.log("desc");
      setSortOrder({ fieldName: "name", direction: "desc" });
    }
  };
  const handleEmailSort = async (order) => {
    if (order == "asc") {
      setSortOrder({ fieldName: "email", direction: "asc" });
    } else {
      console.log("desc");
      setSortOrder({ fieldName: "email", direction: "desc" });
    }
  };
  const fetchData = async () => {
    try {
      let result;
      if (!lookingData) {
        result = await getAllIssues(
          lookingData,
          pageInfo.page,
          pageInfo.size
        );
      } else {
        result = await getAllIssues(lookingData, pageInfo.page, pageInfo.size);
      }
      const response = result.data.data;
      setProfileData(response);
      const formattedData = await response.map((item) => ({
        id: item.id,
        createdDate: item.createdDate,
        name: item.name,
        email: item.email,
        comment: item.comment,
        university: item.university,
        country: item.country,
        course: item.course,
        status: item.status,
        category: item.category,
        masterDataEntityId: item.masterDataEntityId,
        userId: item.userId,
      }));
      setData(formattedData);
      console.log("Formatted data ==>",formattedData);
      setPageData(result.data.metaData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleSelectChange = async (value, id) => {
    const singleProfile = profileData.find((item) => item.id === id);
    const updatedProfile = { ...singleProfile, status: value };
    const response = await updateIssuesDetails(id, updatedProfile);
    if (response) {
      fetchData();
    }
    console.log(`Selected ${value} for row id ${id}`);
  };
  const filterApplicationsBasedOnStatus = async (index, Status,category) => {
    getAllIssuesByStatus(Status, category,pageInfo.page, pageInfo.size).then(
      (response) => {
        console.log("filter responce-->", response);
        if (response.request.status == 200 || response.request.status == 201) {
          setPageData(response.data.metaData);
          setData(response.data.data);
          console.log("ResponseStatus", response.data.data);
          setCheckedIndex(index);
        }
      }
    );
  };
  const getAllProfiles = () => {
    fetchData();
    setCheckedIndex(1);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(() => ({
      [name]: value,
    }));
  };
  const applicationFilter = (category) => {
    let status ="";
    if(checkedIndex == 2){
       status ="open";
    }else if(checkedIndex ==3){
      status ="InProgress";
    }else if(checkedIndex == 4){
      status = "closed"
    }else{
      status = "All"
    } 
    const data ={
      ...formData,
      status:status,
      category:category,
    }
    console.log("Filter criteria:", data);
    searchIssues(data, pageInfo.page, pageInfo.size)
      .then((response) => {
        const result = response.data.data;
        console.log("response of the  search users==>", result);
        const formattedData = result.map((item) => ({
        id: item.id,
        createdDate: item.createdDate,
        name: item.name,
        email: item.email,
        comment: item.comment,
        university: item.university,
        country: item.country,
        course: item.course,
        status: item.status,
        userId: item.userId,
        }));
        setData(formattedData);
        setPageData(response.data.metaData);
      })
      .catch((error) => {
        console.error("Error filtering data:", error);
      });
  };
  const mystyle = {
    width: "90%",
    height: "2.2rem",
    borderRadius: "0.6rem",
    border: "none",
    backgroundColor: "transparent",
    outline: "none",
    gap:'6px',
    display: "flex",
    alignItems: "center",  
  };   
  
  const searchbarStyle = {
    display: "flex",
    // backgroundColor: "transparent",
    // backgroundColor: "white",
    width: "50%",
    borderRadius: "15rem",
    marginLeft: "25%",
    justifyContent: "end",
    // boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",

  };
  const lookingForSomeThingElseColumns = [
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "10%",
    },
    {
      title: (
        <>
          <span>Name</span>
          {/* <Button onClick={() => handleNameSort("asc")}>↑</Button>
          <Button onClick={() => handleNameSort("desc")}>↓</Button> */}
        </>
      ),
      dataIndex: "name",
      key: "name",
      width: "10%",
      render: (_, data) => (
        <>
          <div
            onClick={() => {
              setidData(data);
              handleOpenModal();
            }}
          >
            <span>{data.name}</span>
          </div>
        </>
      ),
    },
    {
      title: (
        <>
          <span>Email</span>
          {/* <Button onClick={() => handleEmailSort("asc")}>↑</Button>
          <Button onClick={() => handleEmailSort("desc")}>↓</Button> */}
        </>
      ),
      dataIndex: "email",
      key: "email",
      width: "15%",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      width: "10%",
    },
    {
      title: "Program ",
      dataIndex: "course",
      key: "course",
      width: "10%",
    },
    {
      title: "University ",
      dataIndex: "university",
      key: "university",
      width: "10%",
    },
    {
      title: "Comment ",
      dataIndex: "comment",
      key: "comment",
      width: "20%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "18%",
      render: (_, data) => (
        <Select
          value={data.status}
          onChange={(value) => {
            handleSelectChange(value, data.id);
          }}
          style={{ width: "75%" }}
        >
          <Option value="Open">Open</Option>
          <Option value="InProgress">In Progress</Option>
          <Option value="Closed">Closed</Option>
        </Select>
      ),
    },
  ];
  const someThingWentWrongColumns = [
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "10%",
    },
    {
      title: (
        <>
          <span>Name</span>
          {/* <Button onClick={() => handleNameSort("asc")}>↑</Button>
          <Button onClick={() => handleNameSort("desc")}>↓</Button> */}
        </>
      ),
      dataIndex: "name",
      key: "name",
      width: "10%",
      render: (_, data) => (
        <>
          <div
            onClick={() => {
              setidData(data);
              handleOpenModal();
            }}
          >
            <span>{data.name}</span>
          </div>
        </>
      ),
    },
    {
      title: (
        <>
          <span>Email</span>
          {/* <Button onClick={() => handleEmailSort("asc")}>↑</Button>
          <Button onClick={() => handleEmailSort("desc")}>↓</Button> */}
        </>
      ),
      dataIndex: "email",
      key: "email",
      width: "20%",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      width: "10%",
    },
    {
      title: "Program ",
      dataIndex: "course",
      key: "course",
      width: "18%",
    },
    {
      title: "Comment ",
      dataIndex: "comment",
      key: "comment",
      width: "20%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "20%",
      render: (_, data) => (
        <Select
          value={data.status}
          onChange={(value) => {
            handleSelectChange(value, data.id);
          }}
          style={{ width: "75%" }}
        >
          <Option value="Open">Open</Option>
          <Option value="InProgress">In Progress</Option>
          <Option value="Closed">Closed</Option>
        </Select>
      ),
    },
  ];
  const rowClassName = (record, index) => {
    return index % 2 === 0 ? 'even-row' : 'odd-row';
  };

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <SideBar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">Issues</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Issues</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="checkbox-container">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  onChange={handleCheckbox1}
                  checked={lookingForSomeThingElse}
                  className="checkbox-custom-size"
                />
                Looking For Some Thing Else
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  onChange={handleCheckbox2}
                  checked={someThingWentWrong}
                  className="checkbox-custom-size"
                />
                Found Some Thing Wrong
              </label>
            </div>
            {lookingForSomeThingElse && (
              <div>
                <div
                  className="checkboxgroup"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox2"
                      value="option2"
                      checked={checkedIndex === 1}
                      onClick={() => {
                        getAllProfiles();
                      }}
                    />
                    <label class="form-check-label" for="inlineCheckbox2">
                      All
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox2"
                      value="option2"
                      checked={checkedIndex === 2}
                      onClick={() => {
                        filterApplicationsBasedOnStatus(2, "Open","looking for something else");
                      }}
                    />
                    <label class="form-check-label" for="inlineCheckbox2">
                      Open
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox2"
                      value="option2"
                      checked={checkedIndex === 3}
                      onClick={() => {
                        filterApplicationsBasedOnStatus(3, "InProgress","looking for something else");
                      }}
                    />
                    <label class="form-check-label" for="inlineCheckbox2">
                      In-Progress
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox2"
                      value="option2"
                      checked={checkedIndex === 4}
                      onClick={() => {
                        filterApplicationsBasedOnStatus(4, "Closed","looking for something else");
                      }}
                    />
                    <label class="form-check-label" for="inlineCheckbox2">
                      Closed
                    </label>
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div style={searchbarStyle}>
                    <div style={mystyle}>
                      <input
                         className={isFocused ? "focused gridsearchinput" : "gtr gridsearchinput"}
                        type="text"
                        placeholder="Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                      />
                      <input
                               className={isFocused1 ? "focused gridsearchinput" : "gtr gridsearchinput"}
                        type="text"
                        placeholder="Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}

                 
                        onFocus={() => setIsFocused1(true)}
                        onBlur={() => setIsFocused1(false)}
                      />
                    </div>
                    <div
                      className="searchbox"
                      type="button"
                      onClick={() => applicationFilter("looking for something else")}
                    >
                      <i className="fas fa-search"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <MyForm
                    isVisible={isModalVisible}
                    onCancel={handleCloseModal}
                    data={idData}
                  />
                </div>
                <div className="width=100%"></div>
                <div style={{ marginTop: "1rem" ,    boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", marginBottom: "1rem"}}>
                  <Table
                    pagination={false}
                    columns={lookingForSomeThingElseColumns}
                    dataSource={data}
                    rowClassName={rowClassName}

                  />
                  {pagedata?.totalPages > 1 && (
                    <Pagination
                      pageResponce={pagedata}
                      pagedataToParent={setPageInfoData}
                    />
                  )}
                </div>
              </div>
            )}
            {someThingWentWrong && (
              <div>
                <div>
                  <div
                    className="checkboxgroup"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox2"
                        value="option2"
                        checked={checkedIndex === 1}
                        onClick={() => {
                          getAllProfiles();
                        }}
                      />
                      <label class="form-check-label" for="inlineCheckbox2">
                        All
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox2"
                        value="option2"
                        checked={checkedIndex === 2}
                        onClick={() => {
                          filterApplicationsBasedOnStatus(2, "Open","Found SoMETHING WRONG");
                        }}
                      />
                      <label class="form-check-label" for="inlineCheckbox2">
                        Open
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox2"
                        value="option2"
                        checked={checkedIndex === 3}
                        onClick={() => {
                          filterApplicationsBasedOnStatus(3, "InProgress","Found SoMETHING WRONG");
                        }}
                      />
                      <label class="form-check-label" for="inlineCheckbox2">
                        In-Progress
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox2"
                        value="option2"
                        checked={checkedIndex === 4}
                        onClick={() => {
                          filterApplicationsBasedOnStatus(4, "Closed","Found SoMETHING WRONG");
                        }}
                      />
                      <label class="form-check-label" for="inlineCheckbox2">
                        Closed
                      </label>
                    </div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div style={searchbarStyle}>
                      <div style={mystyle}>
                        <input
                          className="gridsearchinput"
                          type="text"
                          placeholder="Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        <input
                          className="gridsearchinput"
                          type="text"
                          placeholder="Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                      <div
                        className="searchbox"
                        type="button"
                        onClick={() => applicationFilter("Found SoMETHING WRONG")}
                      >
                        <i className="fas fa-search"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                  </div>
                  <div className="width=100%"></div>
                  <div style={{ marginTop: "1rem" ,    boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", marginBottom: "1rem"}}>
                    <Table
                      pagination={false}
                      columns={someThingWentWrongColumns}
                      dataSource={data}
                      rowClassName={rowClassName}

                    />
                    {pagedata?.totalPages > 1 && (
                      <Pagination
                        pageResponce={pagedata}
                        pagedataToParent={setPageInfoData}
                      />
                    )}
                  </div>
                </div>{" "}
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Issues;
